import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetCommissionRatesResponse, PostCommissionRatesArgs } from "../schemas";

export const usePostCommissionRates = () => {
  const client = useApiClient();

  return useMutation<GetCommissionRatesResponse, Error, PostCommissionRatesArgs>({
    mutationFn: args => client.postCommissionRates(args),
  });
};
